export enum Languages {
  ru = 'ru'
}
export const SUPPORTED_LANGUAGES = [Languages.ru];

export const KZ_PHONE_MASK = '+7 (___) ___-__-__';
export const COMMON_DATE_FORMAT = 'DD.MM.YYYY, HH:mm';
export const WIDTH_FOR_OPENED_NAVBAR = 1140;
export const SYMBOLS = {
  longDash: '\u2014', // —
  tenge: '\u20B8' // ₸
};

export enum UserPositions {
  Director = '4',
  Admin = '5',
  Reports = '6',
  LeasingManager = 'leasing_manager',
  LeasingDirector = 'leasing_director',
  Underwriter = '1001',
  MonitoringManager = 'monitoring_manager',
  CarAppraiser = 'car_appraiser'
}

export enum UserActions {
  ManualDecisions = 10
}

export enum DictTypes {
  Branches = 'Branches', // Филиалы
  DocumentTypes = 'Document_Types', // Тип документа
  MaritalStatuses = 'Marital_Statuses', // Семейное положение
  SocialStatuses = 'Social_Statuses', // Социальный статус
  OrganizationTypes = 'Organization_Types', // Вид организации
  RepaymentTypes = 'Repayment_Types', // Схема оплаты
  Statuses = 'Statuses', // Статусы
  Genders = 'Genders', // Пол
  EngineTypes = 'Engine_Types', // Тип двигателя
  AutoTypes = 'Auto_Types', // Тип авто
  Brands = 'Brands', // Марка
  Models = 'Models', // Модель
  Partners = 'Partners', // Партнеры
  Modules = 'Modules', // Модули
  Countries = 'Countries', //Страны
  LeasingProducts = 'Leasing_Products', //Продукты (StockBoundaries)
  Drive_Types = 'Drive_Types', // тип привода
  Gearbox_Types = 'Gearbox_Types', //тип коробки
  Equipments_Types = 'Equipments_Types', // класс комплектации (Luxe, Sport, Base)
  Cities = 'Cities', // Список городов
  AddContactsIsRelated = 'Client_Contact_Relation_Types', // Кем приходится
  Positions = 'Positions', // Должности
  Colors = 'Colors', // Цвет авто
  SystemSettings = 'System_Settings', // Системные настройки
  ConditionTypes = 'Condition_Types',
  ProductTypes = 'Product_Types',
  ClientTypes = 'Client_Types' // Тип клиента
}

export type DictTypesKeys = `${DictTypes}`;

export const LEASING_STATUSES_COLORS = {
  financed: {
    color: 'white',
    bgColor: '#0CAF60'
  },
  approved: {
    color: 'white',
    bgColor: '#0CAF60'
  },
  declined: {
    color: 'white',
    bgColor: '#FF2E1F'
  },
  on_review: {
    color: 'black',
    bgColor: 'rgb(255, 208, 35)'
  },
  leasing_created: {
    color: 'white',
    bgColor: '#323B49'
  },
  leasing_draft: {
    color: '#A0AEC0',
    bgColor: '#F1F2F4'
  },
  not_sent: {
    color: '#111827',
    bgColor: '#323B49'
  },
  archive: {
    color: '#A0AEC0',
    bgColor: '#F1F2F4'
  }
};
